import Wrapper from '@components/image/WrapperFilling'
import Image from 'next/image'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'

import styles from 'styles/NoMap.module.css'

const NoMap = ({ message = 'Sprzedawca nie podał współrzędnych' }) => {
    return (
        <Wrapper>
            <Image
                src="/fallback/brak-mapy.webp"
                alt={message}
                layout="fill"
                objectFit="cover" />

            <p className={styles.msg}><Icon>location_off</Icon> {useT(message)}</p>
        </Wrapper>
    )
}

export default NoMap